"use client";

import React from "react";
import { HistoryProvider } from "@/contexts/HistoryContext";

interface EditorV2LayoutProps {
  children: React.ReactNode;
}

export default function EditorV2Layout({ children }: EditorV2LayoutProps) {
  return <HistoryProvider>{children}</HistoryProvider>;
}

